import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { Term, TermProps } from './termsTypes';

const syncTermsPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<TermProps>>();
const termPayloadCreator = getPayloadCreator<Term>();

export const getTerms = createAction('GET_TERMS', getPayloadCreator());
export const getTermsSuccess = createAction('GET_TERMS_SUCCESS', syncTermsPayloadCreator);
export const getTermsFailure = createAction('GET_TERMS_FAILURE', errorPayloadCreator);

export const createTerm = createAction('CREATE_TERM', termPayloadCreator);
export const createTermSuccess = createAction('CREATE_TERM_SUCCESS', termPayloadCreator);
export const createTermFailure = createAction('CREATE_TERM_FAILURE', errorPayloadCreator);

export const deleteTerm = createAction('DELETE_TERM', termPayloadCreator);
export const deleteTermSuccess = createAction('DELETE_TERM_SUCCESS', termPayloadCreator);
export const deleteTermFailure = createAction('DELETE_TERM_FAILURE', errorPayloadCreator);
